import React from "react";

const ITEMS = [
  "Roof Rejuvenation",
  "Roof Repair",
  "Custom Homes",
  "Renovations",
  "Design-Build",
  "Developments",
  "Owner's Rep",
  "Consulting",
  "Coastal Builds",
  "Remodels",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="marquee-section"
      className="relative border-y border-white/10 bg-[var(--bg-secondary)] py-6 overflow-hidden"
    >
      <div className="marquee-track flex gap-12 whitespace-nowrap will-change-transform">
        {row.map((t, i) => (
          <div key={i} className="flex items-center gap-12">
            <span className="font-display italic text-2xl md:text-3xl text-[var(--text-primary)]">
              {t}
            </span>
            <span className="text-[var(--accent)]">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
}
